module.exports = __webpack_public_path__ + "static/media/18ECA50.30bbd1c2.jpg";